import React from 'react';

import {labels} from '../../../../../util/utils';
import {contactListColumnIds} from '../../../../../util/uiconstants';

import OutputText from '@ey/canvascoreservices/OutputText';

const ServiceLineColumn = ({item}) => {
	const text = item.isInternal && item?.serviceLineName !== undefined ? item.serviceLineName : labels.notApplicable;

	return (
		<OutputText body2 light ellipsis title={text}>
			{text}
		</OutputText>
	);
};

export const config = (labels) => ({
	id: contactListColumnIds.serviceLine,
	label: labels.columnServiceLine,
	propName: 'svcLine',
	width: 'var(--px-200)',
	sortBy: ['serviceLineName', 'name', 'lastName'],
	customCell: (item) => {
		const props = {item};
		return <ServiceLineColumn {...props} />;
	}
});
